import { FullWidthWhiteBox } from '@/src/modules/account/AccountStyledComponents'
import Button from '@/src/common/components/marketing/buttons/Button'
import HeadlineEyebrow from '@/src/common/components/marketing/headlines/HeadlineEyebrow'
import { IRedemptionOptions } from '@/src/common/queries/FetchReceivedGiftDetails'
import { usePGPlusStepAndModalContext } from '@/src/common/contexts/PGPlusModalAndStepContext'
import {
    DISPATCH_CHANGE_BRAND_MODAL,
    DISPATCH_EDIT_SAVED_CARDS_MODAL,
    DISPATCH_REDEEM_EGIFT_MODAL,
    DISPATCH_REDEEM_PLASTIC_MODAL,
    DISPATCH_UNBRANDED_TO_EGIFT,
} from '@/src/common/reducers/constants'
import {
    EDIT_SAVED_CARDS,
    UNBRANDED_TO_EGIFT,
} from '@/src/modules/pg-plus/constants'

interface IOptions {
    redemptionOptions: IRedemptionOptions | undefined
    isEgift: boolean
}

const BrandedRedemptionButtons = ({ redemptionOptions, isEgift }: IOptions) => {
    const { dispatch, giftState, setSelection } = usePGPlusStepAndModalContext()
    const { isPgPlus } = giftState

    return (
        <FullWidthWhiteBox className={'white-box'}>
            <HeadlineEyebrow
                label={'Ready for something new?'}
                className={'headline-eyebrow'}
            />
            <p>
                BuyGiftCards.com offers the most flexible gifts in the nation.
            </p>
            {redemptionOptions?.redeemable_via_egift && !isEgift && (
                <Button
                    variant={'primaryOutline'}
                    label={'get an egift'}
                    textTransform={'uppercase'}
                    showArrow={true}
                    onClick={() => {
                        isPgPlus && setSelection(UNBRANDED_TO_EGIFT)
                        dispatch({
                            type: isPgPlus
                                ? DISPATCH_UNBRANDED_TO_EGIFT
                                : DISPATCH_REDEEM_EGIFT_MODAL,
                        })
                    }}
                />
            )}
            {redemptionOptions?.redeemable_via_plastic && (
                <Button
                    variant={'primaryOutline'}
                    label={'get a visa gift card'}
                    textTransform={'uppercase'}
                    showArrow={true}
                    onClick={() => {
                        dispatch({
                            type: DISPATCH_REDEEM_PLASTIC_MODAL,
                        })
                    }}
                />
            )}
            {!isPgPlus && redemptionOptions?.brand_change_allowed && (
                <Button
                    variant={'primaryOutline'}
                    label={'swap for another brand'}
                    textTransform={'uppercase'}
                    showArrow={true}
                    onClick={() => {
                        dispatch({
                            type: DISPATCH_CHANGE_BRAND_MODAL,
                        })
                    }}
                />
            )}
            {!isPgPlus && redemptionOptions?.redeemable_via_card_link && (
                <Button
                    variant={'primaryOutline'}
                    label={'Activation methods'}
                    textTransform={'uppercase'}
                    showArrow={true}
                    onClick={() => {
                        setSelection(EDIT_SAVED_CARDS)
                        dispatch({
                            type: DISPATCH_EDIT_SAVED_CARDS_MODAL,
                        })
                    }}
                />
            )}
        </FullWidthWhiteBox>
    )
}

export default BrandedRedemptionButtons
